module.exports = __webpack_public_path__ + "Dashboard.761927c49a49d5123e30.png";